const Breakpoints = {
    xsm: '320px',
    sm: '375px',
    md: '768px',
    lg: '1024px',
    xlg: '1440px'
}

export default Breakpoints;